import React, { useEffect } from "react";
import {
  WSActions,
  WSCard,
  WSGrid,
  WSInfoBox,
  WSList,
  WSText,
  toWSDateString
} from "@wingspanhq/fe-component-library";
import { useFlowContext } from "../../../../shared/components/Flow";
import { DataItem } from "../../../../shared/components/DataItem";
import { EnrollMeridioFlowState } from "./types";
import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

export const StepConfirmDependents: React.FC<FlowStep> = props => {
  const [flowState, setFlowState] = useFlowContext<EnrollMeridioFlowState>();

  const handleContinue = () => {
    setFlowState(prev => ({ ...prev, informationConfirmed: true }));
    props.onNext?.();
  };

  useEffect(() => {
    if (!flowState.dependents?.length) {
      setFlowState(prev => ({ ...prev, informationConfirmed: true }));
      props.onNext?.();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!flowState.dependents?.length) {
    return null;
  }

  return (
    <>
      <WSText.Heading3 weight="medium" mb="S">
        Confirm dependents
      </WSText.Heading3>
      <WSText.ParagraphSm weight="book" color="gray500" mb="XL">
        Confirm information about each person who will be covered by your plan.
      </WSText.ParagraphSm>

      <WSList gap="XL">
        <WSCard>
          <WSInfoBox transparent icon="help-circle">
            {"{Standard_coverage_and_validation_language_by_Meridio}"}
            <WSText.ParagraphSm mt="XS">
              <b>Insurer:</b> {"{Meridio_info}"}
            </WSText.ParagraphSm>
          </WSInfoBox>
        </WSCard>

        <WSList gap="XL">
          {flowState.dependents.map((dep, i) => {
            const ssnLast4 = (dep.ssn as string)?.slice(-4);
            const dataItems = [
              { label: "Legal first name", value: dep.firstName ?? "—" },
              { label: "Legal last name", value: dep.lastName ?? "—" },
              {
                label: "Date of birth",
                value: dep.dob
                  ? toWSDateString(new Date(dep.dob as any), "monthDayYear")
                  : "—"
              },
              { label: "Gender", value: dep.gender ?? "—" },
              { label: "Relationship", value: dep.relationship ?? "—" },
              {
                label: "SSN",
                value: ssnLast4 ? `***-**-${ssnLast4}` : "—"
              }
            ];
            return (
              <WSCard key={i}>
                <WSText weight="medium" mb="XL">
                  Dependent {i + 1}
                </WSText>
                <WSGrid gutter="2XL">
                  {dataItems.map(item => (
                    <WSGrid.Item key={item.label} span={{ xs: "12", s: "6" }}>
                      <DataItem label={item.label} value={item.value} />
                    </WSGrid.Item>
                  ))}
                </WSGrid>
              </WSCard>
            );
          })}
        </WSList>
      </WSList>

      <WSActions
        mt="XL"
        alignment="fill"
        buttons={[
          { kind: "Tertiary", label: "Back", onClick: props.onBack },
          { label: "Continue", onClick: handleContinue }
        ]}
      />
    </>
  );
};
